import { documentLocale } from "@frontend/stores";
import { useLingui } from "@lingui/react";

export function useIntlLocale(): string {
  const { i18n } = useLingui();

  return documentLocale.startsWith(i18n.locale) ? documentLocale : i18n.locale;
}
